import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const NewConnectionGasFeedsForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, submitChange } = useFormModel<
        ChangeNames.NEW_CONNECTION_GAS_FEEDS
    >();

    const convertValue = (): string => {
        if (values.newConnectionGasFeeds.value.interior) return "interior";
        if (values.newConnectionGasFeeds.value.exterior) return "exterior";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Ausführungsvariante für Gas
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues(values => {
                                values.newConnectionGasFeeds.value = {
                                    interior: v.indexOf("interior") >= 0,
                                    exterior: v.indexOf("exterior") >= 0,
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <FormControlLabel
                            value="interior"
                            control={<Radio />}
                            label="Innenanschluss"
                            text="Bei der Innenanschlusstechnik wird die Hauseinführungskombination (HEK) im Hausanschlussraum installiert. Hier sind ebenfalls die Anschlüsse für beispielsweise Strom, Gas, Wasser und Telefon untergebracht. Alternativ kann die Montage auch im Aufstellraum der Verbrauchereinrichtung erfolgen. Der Druckregler wird fachgerecht hinter dem Absperrhahn der HEK montiert."
                            error={values.newConnectionGasFeeds.error !== null}
                        />
                        <FormControlLabel
                            value="exterior"
                            control={<Radio />}
                            label="Außenanschluss"
                            text="Bei der Außenanschlusstechnik wird der Netzanschluss außerhalb des Gebäudes auf Ihrem Grundstück errichtet. Dadurch entfällt der Platzbedarf für den Netzanschluss im Gebäude."
                            error={values.newConnectionGasFeeds.error !== null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
